export default function FounderBio() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">Meet the Founder</h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto"></div>
        </div>
        
        <div className="max-w-5xl mx-auto">
          <div className="bg-gradient-to-br from-amber-50 to-white rounded-2xl p-8 md:p-12 shadow-xl border-l-4 border-amber-500 mb-12">
            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 mb-8">
              <div className="w-24 h-24 bg-amber-500 rounded-full flex items-center justify-center overflow-hidden flex-shrink-0">
                <img 
                  src="https://static.readdy.ai/image/18c9072bd71adb24a96e04ea147e8334/78b8a677902e032576de98212e68b92a.jpeg" 
                  alt="Katya McGregor - Founder of APEX"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="text-center sm:text-left">
                <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">Katya McGregor</h3>
                <p className="text-lg md:text-xl text-amber-600 font-semibold">Founder &amp; Professional Book Promoter</p>
              </div>
            </div>
            
            <div className="space-y-5 text-base md:text-lg text-gray-700 leading-relaxed">
              <p>
                I founded APEX after spending years in the book promotion industry, where I discovered a crucial gap: authors needed a way to connect with readers who would genuinely engage with their work, not just passive audiences.
              </p>
              
              <p>
                Over the years, I've built relationships with over 300 highly engaged book clubs—both online and in-person communities. I've learned what makes readers excited about a book, how to position stories so they resonate, and which books will spark meaningful discussions.
              </p>
              
              <p>
                My approach is selective and strategic. I evaluate every book carefully using Amazon and Goodreads descriptions, platforms like Readnrate to understand reader interests, and my own expertise to determine if it's the right fit for our book club network.
              </p>
              
              <p>
                I work with respected and recognized book clubs that have established reputations in the literary community. These aren't casual reading groups—they're active, engaged communities where members read thoughtfully, discuss passionately, and review honestly.
              </p>
              
              <p className="font-semibold text-gray-900 pt-2">
                At APEX, we don't promote every book. We choose standout titles for our limited campaign slots because maintaining quality and credibility is essential to our success—and yours.
              </p>
            </div>
          </div>
          
          <div className="grid sm:grid-cols-2 gap-6 md:gap-8">
            <div className="bg-white rounded-xl p-6 md:p-8 shadow-lg border-2 border-amber-200">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-amber-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-team-line text-xl md:text-2xl text-white"></i>
                </div>
                <h4 className="text-xl md:text-2xl font-bold text-gray-900">My Network</h4>
              </div>
              <ul className="space-y-3 md:space-y-4 text-sm md:text-base text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-lg md:text-xl text-amber-600 mt-0.5 flex-shrink-0"></i>
                  <span>Over 300 active book clubs across multiple genres and platforms</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-lg md:text-xl text-amber-600 mt-0.5 flex-shrink-0"></i>
                  <span>Established relationships with both online communities and in-person reading groups</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-lg md:text-xl text-amber-600 mt-0.5 flex-shrink-0"></i>
                  <span>Verified track record of engaged readers who actively review and recommend books</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-lg md:text-xl text-amber-600 mt-0.5 flex-shrink-0"></i>
                  <span>Diverse reader demographics spanning different age groups and reading preferences</span>
                </li>
              </ul>
            </div>
            
            <div className="bg-white rounded-xl p-6 md:p-8 shadow-lg border-2 border-amber-200">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-amber-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-lightbulb-line text-xl md:text-2xl text-white"></i>
                </div>
                <h4 className="text-xl md:text-2xl font-bold text-gray-900">My Approach</h4>
              </div>
              <ul className="space-y-3 md:space-y-4 text-sm md:text-base text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-lg md:text-xl text-amber-600 mt-0.5 flex-shrink-0"></i>
                  <span>Careful evaluation of each book's potential for genuine reader engagement</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-lg md:text-xl text-amber-600 mt-0.5 flex-shrink-0"></i>
                  <span>Strategic matching between books and the most suitable book club audiences</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-lg md:text-xl text-amber-600 mt-0.5 flex-shrink-0"></i>
                  <span>Transparent communication throughout the entire promotion process</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-lg md:text-xl text-amber-600 mt-0.5 flex-shrink-0"></i>
                  <span>Focus on quality over quantity—limited campaign slots ensure maximum attention</span>
                </li>
              </ul>
            </div>
            
            <div className="bg-white rounded-xl p-6 md:p-8 shadow-lg border-2 border-amber-200">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-amber-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-xl md:text-2xl text-white"></i>
                </div>
                <h4 className="text-xl md:text-2xl font-bold text-gray-900">Communication</h4>
              </div>
              <div className="space-y-4 text-sm md:text-base text-gray-700 leading-relaxed">
                <p>
                  I primarily communicate through email to ensure clarity, maintain detailed records, and respect your time. This allows for thoughtful responses and clear documentation of our campaign strategy.
                </p>
                <p>
                  You'll receive regular updates on campaign progress, book club feedback, and review tracking throughout our partnership.
                </p>
              </div>
            </div>
            
            <div className="bg-white rounded-xl p-6 md:p-8 shadow-lg border-2 border-amber-200">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-amber-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-award-line text-xl md:text-2xl text-white"></i>
                </div>
                <h4 className="text-xl md:text-2xl font-bold text-gray-900">Experience</h4>
              </div>
              <div className="space-y-4 text-sm md:text-base text-gray-700 leading-relaxed">
                <p>
                  Years of experience in book promotion have taught me what works and what doesn't. I've seen trends come and go, but authentic reader engagement remains the most powerful tool for book success.
                </p>
                <p>
                  My expertise lies in understanding both the author's vision and the reader's expectations, then bridging that gap effectively.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
